// extracted by mini-css-extract-plugin
module.exports = {"switch":"cd01fbf7b5--switch--Iu4Bo","indicator":"cd01fbf7b5--indicator--JD6wH","disabled":"cd01fbf7b5--disabled--WS_Zh"};